import { FixedTermAnnuity } from "../../../../modules/common/info-articles/FixedTermAnnuity";
import { FlexibleAccessDrawdown } from "../../../../modules/common/info-articles/FlexibleAccessDrawdown";
import { LifetimeAnnuity } from "../../../../modules/common/info-articles/LifetimeAnnuity";

export type QuoteExplainerType = "lifetime" | "fixed" | "drawdown";

type QuoteExplainerDrawerProps = {
  type: QuoteExplainerType;
  onClose: () => void;
};

const explainerTitles: Record<QuoteExplainerType, string> = {
  lifetime: "What is a Lifetime Annuity?",
  fixed: "What is a Fixed Term Annuity?",
  drawdown: "What is Pension Drawdown?",
};

export function QuoteExplainerDrawer({ type, onClose }: QuoteExplainerDrawerProps) {
  return (
    <div className="lv2-info-drawer-overlay" role="dialog" aria-modal="true" aria-label={explainerTitles[type]}>
      <aside className="lv2-info-drawer">
        <header>
          <h2>{explainerTitles[type]}</h2>
          <button type="button" onClick={onClose} aria-label="Close">
            &times;
          </button>
        </header>
        <div className="lv2-info-drawer-body">
          {type === "lifetime" && <LifetimeAnnuity showAction={false} />}
          {type === "fixed" && <FixedTermAnnuity showAction={false} />}
          {type === "drawdown" && <FlexibleAccessDrawdown showAction={false} />}
        </div>
      </aside>
    </div>
  );
}
